import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { Platform } from '@ionic/angular';
import { first } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

@Injectable({
    providedIn: 'root'
})
export class FcmService {
    
    private _token:any;

    /**
     * Constructor
     */
    constructor(
        private apiService:ApiService,
        private platform:Platform,
        private router: Router
    ) {
        
    }
    
    /**
     * Init
     */
    public async init() {
        if (Capacitor.isPluginAvailable('PushNotifications')) {
            let permStatus = await PushNotifications.checkPermissions();
            
            if (permStatus.receive === 'prompt' || permStatus.receive === 'prompt-with-rationale') {
                permStatus = await PushNotifications.requestPermissions();
            }
            
            if (permStatus.receive !== 'granted') {
                throw new Error('User denied permissions!');
            }
            
            await PushNotifications.register();

            // if (this._token) {
            //     this.apiService.setDeviceId(this._token.value, this.platform.is('ios') ? 'ios' : 'android').pipe(first()).subscribe()
            // } else {
                await PushNotifications.addListener('registration', token => {
                    // console.info('Registration token: ', token);
    
                    try {
                        this._token = token;
                        this.apiService.setDeviceId(token.value, this.platform.is('ios') ? 'ios' : 'android').pipe(first()).subscribe()
                    } catch(e) {
                        
                    }
                });   
            // }
        
            await PushNotifications.addListener('registrationError', err => {
                // console.error('Registration error: ', err.error);
            });
        
            await PushNotifications.addListener('pushNotificationReceived', notification => {
                PushNotifications.removeAllDeliveredNotifications();
            });
            
            
            await PushNotifications.addListener('pushNotificationActionPerformed', notification => {
                const data = notification.notification.data;
                if (data.target) {                    
                    this.router.navigateByUrl(data.target);
                }
            });

            PushNotifications.removeAllDeliveredNotifications();
        }
    }

    /**
     * Clear
     */
    public async clear() {

        if (this._token) {
            try {
                this.apiService.deleteDeviceId(this._token.value).pipe(first()).subscribe()
            } catch(e) {}
        }

        if (Capacitor.isPluginAvailable('PushNotifications')) {
            PushNotifications.removeAllListeners();
        }
    }
}
